import { createFileRoute } from '@tanstack/react-router'
import { PatientDeletePage } from '@/features/patients/delete'

export const Route = createFileRoute('/patients_/$patientId/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const { patientId } = Route.useParams()
  return <PatientDeletePage patientId={patientId} />
}
